import React from 'react';
import styles from '../assets/styles/ServicesSection.module.css';
import ServiceCategoryCard from './ServiceCategoryCard';
import { FaHandcuffs } from "react-icons/fa6";
import { MdFamilyRestroom } from "react-icons/md";
import { FaFileContract } from "react-icons/fa6";
import { FaGlobeAsia } from "react-icons/fa";

const ServicesSection = () => {
  return (
    <div>
      <div className={styles.servicesSection}>
      <div className="section-title">What We Do</div>
        <div className={styles.serviceCardContainer}>
          <ServiceCategoryCard
            icon={<FaHandcuffs />}
            title="Criminal Law"
            description="Providing legal defense and representation in criminal cases. Our lawyers ensure fair trials and protect clients' rights throughout the legal process."
            path="/services/criminal"
          />
          <ServiceCategoryCard
            icon={<MdFamilyRestroom />}
            title="Family Law"
            description="Assisting with matters like divorce, property, and family disputes. We offer compassionate legal guidance to help families navigate complex personal challenges."
            path="/services/family"
          />
          <ServiceCategoryCard
            icon={<FaFileContract />}
            title="Civil & Commercial Litigation"
            description="Resolving legal conflicts in business and personal civil matters. Our team advocates for clients in negotiations, mediations, and court proceedings."
            path="/services/civil-commercial"
          />
          <ServiceCategoryCard
            icon={<FaGlobeAsia />}
            title="Immigration Law"
            description="Guiding individuals and businesses through immigration processes and legal requirements. We assist with visas, residency applications, and citizenship matters with precision and care."
            path="/services/immigration"
          />
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
